<template>
<ManualSection :header="header" :open="open" @click="$emit('click')" :state="userFoto ? 'success' : 'danger'" code="photo">
    <template v-slot:pre>
        <img v-if="!open && userFoto" :src="userFoto" alt="Фото" width="45" style="float: right; display: block" />
    </template>

    <template v-slot:comment>
        <p v-if="!userFoto" class="cmnt">В пропорции 3:4, для членской карты.</p>
        <p class="cmnt" v-else>Фото загружено.</p>
    </template>

    <PhotoSection :showHeader="false" @uploaded="uploadedHandler" />
</ManualSection>
</template>

<script>
import ManualSection from '@/components/ManualSection.vue'
import PhotoSection from '@/components/PhotoSection.vue'

export default {
    props: {
        header: String,
        open: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        ManualSection,
        PhotoSection
    },
    data() {
        return {
        }
    },
    computed: {
        userFoto() {
            return this.$store.getters.getUserData.memberInfo?.photo
        }
    },
    methods: {
        uploadedHandler() {
            this.$store.dispatch('loginWithCookie');
        }
    }
}
</script>
